import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WebsiteRoutingModule } from './website-routing.module';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { WhyHuiospayComponent } from './why-huiospay/why-huiospay.component';
import { DeveloperSectionComponent } from './developer-section/developer-section.component';
import { CareersComponent } from './careers/careers.component';
import { CustomerReviewComponent } from './customer-review/customer-review.component';
import { FaqsComponent } from './faqs/faqs.component';
import { TrainingDevelopmentComponent } from './training-development/training-development.component';
import { BecomeMerchantComponent } from './become-merchant/become-merchant.component';
import { QuickHelpComponent } from './quick-help/quick-help.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CourseDetailsComponent } from './course-details/course-details.component';
import { BecomeAgentComponent } from './become-agent/become-agent.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CookiesPolicyComponent } from './cookies-policy/cookies-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DataProtectionComponent } from './data-protection/data-protection.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { NewLandingPageComponent } from './new-landing-page/new-landing-page.component';
import { NewWhyHuiospayComponent } from './new-why-huiospay/new-why-huiospay.component';
import { NewDevelopersComponent } from './new-developers/new-developers.component';
import { NewAboutUsComponent } from './new-about-us/new-about-us.component';
import { NewCareersComponent } from './new-careers/new-careers.component';
import { NewSupportComponent } from './new-support/new-support.component';
import { NewTermsConditionsComponent } from './new-terms-conditions/new-terms-conditions.component';
import { NewPrivacyPolicyComponent } from './new-privacy-policy/new-privacy-policy.component';
import { NewDataProtectionComponent } from './new-data-protection/new-data-protection.component';


@NgModule({
  declarations: [
    LandingPageComponent,
    WhyHuiospayComponent,
    DeveloperSectionComponent,
    CareersComponent,
    CustomerReviewComponent,
    FaqsComponent,
    TrainingDevelopmentComponent,
    BecomeMerchantComponent,
    QuickHelpComponent,
    ContactUsComponent,
    AboutUsComponent,
    CourseDetailsComponent,
    BecomeAgentComponent,
    CheckoutComponent,
    CookiesPolicyComponent,
    PrivacyPolicyComponent,
    DataProtectionComponent,
    TermsAndConditionsComponent,
    NewLandingPageComponent,
    NewWhyHuiospayComponent,
    NewDevelopersComponent,
    NewAboutUsComponent,
    NewCareersComponent,
    NewSupportComponent,
    NewTermsConditionsComponent,
    NewPrivacyPolicyComponent,
    NewDataProtectionComponent
  ],
  imports: [
    CommonModule,
    WebsiteRoutingModule,
    ComponentsModule,
    FormsModule,
    ReactiveFormsModule,
    ],
  exports: [
    // LandingPageComponent
  ]
})
export class WebsiteModule { }
